import React, { useEffect, useRef, useState } from 'react'
// import { API, graphqlOperation } from 'aws-amplify';
import RatingFeedRating from './ratingfeedrating';
import { useQuery, gql } from '@apollo/client';
import { getRatingsByDate, getRatingsByOwner } from '../../graphql/queries';
import RMPLoader from '../rmp/rmploader';
import { useUser } from '../../helpers/user';
import { useRouteMatch, useHistory, useLocation } from 'react-router';
import * as qs from 'qs'

const PAGE_SIZE = 20

function sortItems(items, sort) {
    if (sort === 'liked') {
        return [...items].sort((a, b) => (b.likes?.items?.length ?? 0) - (a.likes?.items?.length ?? 0))
    }
    if (sort === 'commented') {
        return [...items].sort((a, b) => (b.comments?.items?.length ?? 0) - (a.comments?.items?.length ?? 0))
    }
    return items
}

export default function RatingFeed({ owner, sort = 'recent' }) {
    const { url: baseRoute, ...rest } = useRouteMatch()
    const { search } = useLocation()
    const expanded = qs.parse(search, { ignoreQueryPrefix: true }).id
    const history = useHistory()
    const sentinelRef = useRef(null)
    const [isFetchingMore, setIsFetchingMore] = useState(false)

    const clientSort = sort === 'liked' || sort === 'commented'
    const sortDirection = sort === 'oldest' ? 'ASC' : 'DESC'
    const limit = clientSort ? 500 : PAGE_SIZE

    const query = owner ? gql(getRatingsByOwner) : gql(getRatingsByDate)
    const variables = owner
        ? { owner, sortDirection, limit }
        : { type: "Rating", sortDirection, limit }

    const { data, loading, error, fetchMore } = useQuery(query, { variables })
    const {user} = useUser()

    const resultKey = owner ? 'getRatingsByOwner' : 'getRatingsByDate'
    const nextToken = clientSort ? null : data?.[resultKey]?.nextToken

    useEffect(() => {
        if (!sentinelRef.current) return
        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && nextToken && !isFetchingMore) {
                setIsFetchingMore(true)
                fetchMore({
                    variables: { nextToken },
                    updateQuery: (prev, { fetchMoreResult }) => {
                        if (!fetchMoreResult) return prev
                        const existingIds = new Set(prev[resultKey].items.map(i => i.id))
                        const newItems = fetchMoreResult[resultKey].items.filter(i => !existingIds.has(i.id))
                        return {
                            [resultKey]: {
                                ...fetchMoreResult[resultKey],
                                items: [
                                    ...prev[resultKey].items,
                                    ...newItems
                                ]
                            }
                        }
                    }
                }).finally(() => setIsFetchingMore(false))
            }
        })
        observer.observe(sentinelRef.current)
        return () => observer.disconnect()
    }, [nextToken, isFetchingMore, fetchMore])

    if (loading && !data) return <RMPLoader/>
    if (error) return "Error"
    if (!data) return <>Loading...</>

    const items = sortItems(data[resultKey].items, sort)

    const handleSetExpanded = (id, shouldExpand) => {
        if (!shouldExpand) {
            history.push({
                pathname: baseRoute,
                search: ''
            })
        } else {
            history.push({
                pathname: baseRoute,
                search: `?id=${id}`
            })
        }
    }
    return <>
        {items.map(r => <RatingFeedRating
            key={r.id}
            rating={r}
            expand={expanded == r.id}
            setExpand={shouldExpand => handleSetExpanded(r.id, shouldExpand)}
        />)}
        <div ref={sentinelRef} />
        {isFetchingMore && <div style={{ textAlign: 'center', padding: '1rem' }}><RMPLoader/></div>}
        {!isFetchingMore && !nextToken && items.length > 0 && (
            <div style={{ textAlign: 'center', padding: '1rem', color: '#888' }}>
                You've reached the end
            </div>
        )}
    </>
}